import { WarehouseTable } from 'modules/warehouse';

const ObjectCardProducts = ({vobjectFull}) => {

    return (
        <>
        <WarehouseTable
            onlyView={true}
            setShowTransfer={null}
            stocksList={vobjectFull?.stocks}/>
        
        </>
    )
}

export default ObjectCardProducts;